module.exports = __webpack_public_path__ + "static/media/email.c66ee6f6.svg";